export default "__VITE_ASSET__VX19qO_R__"